export default __webpack_public_path__ + "static/media/term-condition-vn.15e752f3.svg";